import { render, staticRenderFns } from "./CreateRequisiteModal.vue?vue&type=template&id=d670c792&"
import script from "./CreateRequisiteModal.vue?vue&type=script&lang=js&"
export * from "./CreateRequisiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports